import ModalFooter from '@/UI/ModalFooter';

import type { ModalFuncProps } from 'antd';
import type { HookAPI } from 'antd/es/modal/useModal';

/**
 * Opens a non-destructive confirmation dialog via antd's imperative modal API.
 * Standardizes the confirm anatomy: an info-blue icon (antd's default warning
 * amber reads muddy on white) and both buttons bottom-right (Cancel first),
 * matching the app-wide footer convention. For destructive confirmations use
 * {@link confirmDestructive} instead.
 *
 * The `modal` instance must come from `App.useApp()` so the dialog inherits the
 * app's themed ConfigProvider context (required in antd v6).
 */
export function confirmDialog(modal: HookAPI, options: ModalFuncProps) {
  return modal.confirm({
    icon: <></>,
    ...options,
    footer: (_originNode, { OkBtn, CancelBtn }) => (
      <ModalFooter
        actions={
          <>
            <CancelBtn />
            <OkBtn />
          </>
        }
      />
    ),
  });
}
